<template>
  <div
    class="dashboard-block information"
    :class="{ to_c_information: isBtoC }">
    <div class="dashboard-block__heading">
      <h3 class="dashboard-block__title c-with-icon">
        <svg
          class="icon-alert svg-icon"
          viewBox="0 0 40 51.95">
          <path
            class="color1"
            d="M14,46H26a6,6,0,0,1-12,0Zm26-4H0C7.71,32.25,5.73,13.84,14.9,
            9.1A6,6,0,0,1,14,6a6,6,0,0,1,6-6h0a6,6,0,0,1,6,6V6a5.94,5.94,0,
            0,1-.89,3.12C34.25,13.94,32.29,32.27,40,42ZM19.62,8,20,8l.47,0a2,
            2,0,0,0,1.59-2h0a2,2,0,0,0-2-2h0a2,2,0,0,0-.44,4ZM6.86,
            38H33.14a76.23,76.23,0,0,1-3.45-11.38c-2.45-9.94-4-14.23-9-14.58l-.63,
            0h0a4.73,4.73,0,0,1-.65,0c-5.05.32-6.63,4.6-9.1,14.61A75.89,75.89,0,0,1,6.86,38Z" />
        </svg>
        管理者様へのお知らせ
      </h3>
      <router-link
        v-if="items.length > 0"
        :to="{ name: 'information-index' }"
        class="dashboard-block__link">
        お知らせ一覧へ
      </router-link>
    </div>
    <div
      v-if="fixed.length > 0"
      class="dashboard-block__inner dashboard-block__inner--nopadding fixed-information">
      <ul class="information-list">
        <li
          v-for="item in fixed"
          :key="item.id"
          class="information-list__node"
          :class="{ unread: item.read === 0 }">
          <router-link
            :to="{ name: 'information-detail', params: { id: item.id } }"
            class="information-list__link">
            <span
              class="information-list__status"
              :class="item.read === 0
                ? 'information-list__status--unread'
                : 'information-list__status--read'">
              {{ item.read === 0 ? '未読' : '既読' }}
            </span>
            <span class="information-list__date">{{ item.start_date | formatDate }}</span>
            <span class="information-list__text">{{ item.title }}</span>
            <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
          </router-link>
        </li>
      </ul>
    </div>
    <div
      v-if="items.length > 0"
      class="dashboard-block__inner dashboard-block__inner--nopadding">
      <ul class="information-list">
        <li
          v-for="item in items"
          :key="item.id"
          class="information-list__node"
          :class="{ unread: item.read === 0 }">
          <router-link
            :to="{ name: 'information-detail', params: { id: item.id } }"
            class="information-list__link">
            <span
              class="information-list__status"
              :class="item.read === 0
                ? 'information-list__status--unread'
                : 'information-list__status--read'">
              {{ item.read === 0 ? '未読' : '既読' }}
            </span>
            <span class="information-list__date">{{ item.start_date | formatDate }}</span>
            <span class="information-list__text">{{ item.title }}</span>
            <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
          </router-link>
        </li>
      </ul>
    </div>
    <div
      v-else
      class="dashboard-block__inner dashboard-block__inner--nopadding">
      <p class="empty-information">お知らせはございません。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardInformation',
  data() {
    return {
      items: [],
      fixed: [],
    }
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const count = 3
      const response = await window.axios.get(`/api/client/informations?count=${count}`)
      this.items = response.data.data
      this.fixed = response.data.fixed ?? []
    },
  },
}
</script>

<style scoped>
.empty-information {
  margin: auto;
  text-align: center;
  color: #505050;
  padding-top: 5vmin;
  padding-bottom: 5vmin;
}
.fixed-information {
  border-bottom: 1px solid #dadada;
}
.fixed-information ul > li:last-child {
  border: none;
}
.to_c_information {
  margin-bottom: 20px;
}
</style>
